import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/blogPosts';
import { ArrowRight, Clock } from 'lucide-react';

export default function BlogPreviewSection() {
  return (
    <section
      data-testid="blog-preview-section"
      style={{ backgroundColor: '#FFFFFF', padding: '100px 0' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span style={{
              display: 'inline-block',
              backgroundColor: '#EEF2FF',
              color: '#1B3D7E',
              fontSize: '0.65rem',
              letterSpacing: '0.25em',
              textTransform: 'uppercase',
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              padding: '5px 14px',
              borderRadius: '100px',
              marginBottom: '14px',
            }}>
              Knowledge Hub
            </span>
            <h2 style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 800,
              fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
              color: '#0D1A2E',
              lineHeight: 1.15,
              margin: 0,
            }}>
              Learn About Male Health
            </h2>
            <p style={{
              fontFamily: 'Manrope, sans-serif',
              fontSize: '0.9rem',
              color: '#64748B',
              lineHeight: 1.7,
              marginTop: '10px',
              maxWidth: '460px',
            }}>
              Science-backed guides to help you make informed decisions about reproductive health, libido, and supplementation.
            </p>
          </div>
          <Link
            to="/blog"
            data-testid="blog-preview-see-all"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontFamily: 'Manrope, sans-serif',
              fontSize: '0.82rem',
              fontWeight: 700,
              color: '#1B3D7E',
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              letterSpacing: '0.05em',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}>
            View All Articles <ArrowRight size={14} />
          </Link>
        </div>

        {/* Article Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`home-blog-card-${post.slug}`}
              style={{ textDecoration: 'none', display: 'flex' }}>
              <div
                style={{
                  backgroundColor: '#F7F7F5',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  border: '1px solid #E2E8F0',
                  transition: 'box-shadow 0.25s, transform 0.25s',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 12px 36px rgba(27,61,126,0.10)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}>

                {/* Image */}
                <div style={{ height: '180px', overflow: 'hidden', flexShrink: 0 }}>
                  <img
                    src={post.image}
                    alt={post.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s' }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.04)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  />
                </div>

                {/* Content */}
                <div style={{ padding: '22px 24px 26px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <span style={{
                      backgroundColor: '#EEF2FF',
                      color: '#1B3D7E',
                      fontSize: '0.62rem',
                      fontFamily: 'Manrope, sans-serif',
                      fontWeight: 700,
                      letterSpacing: '0.1em',
                      textTransform: 'uppercase',
                      padding: '3px 9px',
                      borderRadius: '100px',
                    }}>
                      {post.category}
                    </span>
                    <span style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                      color: '#94A3B8',
                      fontSize: '0.7rem',
                      fontFamily: 'Manrope, sans-serif',
                    }}>
                      <Clock size={10} />
                      {post.readTime}
                    </span>
                  </div>

                  <h3 style={{
                    fontFamily: 'Outfit, sans-serif',
                    fontWeight: 800,
                    fontSize: '1rem',
                    color: '#0D1A2E',
                    lineHeight: 1.3,
                    marginBottom: '10px',
                    flex: 1,
                  }}>
                    {post.title}
                  </h3>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    color: '#1B3D7E',
                    fontFamily: 'Manrope, sans-serif',
                    fontWeight: 700,
                    fontSize: '0.76rem',
                    marginTop: 'auto',
                  }}>
                    Read Article <ArrowRight size={12} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
